import * as React from "react"

import { EnergyUnit } from "shared/hubrise/models"

interface UIPreferencesInterface {
  generalExpanded: boolean
  setGeneralExpanded: (expanded: boolean) => void
  skusExpanded: boolean
  setSkusExpanded: (expanded: boolean) => void
  dimensionsExpanded: boolean
  setDimensionsExpanded: (expanded: boolean) => void
  optionListsExpanded: boolean
  setOptionListsExpanded: (expanded: boolean) => void
  nutritionExpanded: boolean
  setNutritionExpanded: (expanded: boolean) => void
  defaultEnergyUnit: EnergyUnit | null
  setDefaultEnergyUnit: (unit: EnergyUnit) => void
}

const UIPreferencesContext = React.createContext<UIPreferencesInterface | undefined>(undefined)

export const UIPreferencesProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [generalExpanded, setGeneralExpanded] = React.useState(true)
  const [skusExpanded, setSkusExpanded] = React.useState(true)
  const [dimensionsExpanded, setDimensionsExpanded] = React.useState(false)
  const [optionListsExpanded, setOptionListsExpanded] = React.useState(true)
  const [nutritionExpanded, setNutritionExpanded] = React.useState(false)
  const [defaultEnergyUnit, setDefaultEnergyUnit] = React.useState<EnergyUnit | null>(null)

  const value = React.useMemo(
    () => ({
      generalExpanded,
      setGeneralExpanded,
      skusExpanded,
      setSkusExpanded,
      dimensionsExpanded,
      setDimensionsExpanded,
      optionListsExpanded,
      setOptionListsExpanded,
      nutritionExpanded,
      setNutritionExpanded,
      defaultEnergyUnit,
      setDefaultEnergyUnit,
    }),
    [generalExpanded, skusExpanded, dimensionsExpanded, optionListsExpanded, nutritionExpanded, defaultEnergyUnit],
  )

  return <UIPreferencesContext.Provider value={value}>{children}</UIPreferencesContext.Provider>
}

export function useUIPreferences(): UIPreferencesInterface {
  const context = React.useContext(UIPreferencesContext)

  if (context === undefined) {
    throw new Error(`useUIPreferences must be used within UIPreferencesProvider`)
  }

  return context
}
